export enum NotificationStatus {
  Unread = 'unread',
  Read = 'read',
  MarkedAsUnread = 'marked-as-unread',
  Archived = 'archived'
}
